import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import LinearProgress from '@mui/material/LinearProgress'
import React from 'react'
import { useTranslation, Trans } from 'react-i18next'

interface Props {
    open: boolean
    isLoading?: boolean
    title: string
    content: string
    onCancel: () => void
    onConfirm: () => void
}

export default function ConfirmDialog({ open, onCancel, onConfirm, title, content, isLoading = false }: Props): JSX.Element {
  const { t } = useTranslation()
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      {isLoading && <LinearProgress />}
      <DialogTitle>
        <Trans>{title}</Trans>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Trans>{content}</Trans>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button disabled={isLoading} onClick={onCancel}>{t('cancel')}</Button>
        <Button
          variant="contained"
          disabled={isLoading}
          onClick={onConfirm}
        >
          {t('accept')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
